export default {
  namespaced: true,

  state: {
    currentStep: 1,
  },

  actions: {
    goToStepBrandColorSelection({ dispatch, commit }) {
      dispatch('brand-color-selection/getBrandColorTypes', null, {
        root: true,
      });

      commit('setStep', 2);
    },
    goToStepFinishOrder({ dispatch, commit }) {
      dispatch('order/fetchProducts', null, {
        root: true,
      });

      commit('setStep', 3);
    },
  },

  mutations: {
    nextStep(state) {
      state.currentStep += 1;
    },
    setStep(state, step) {
      state.currentStep = step;
    },
  },
};
